<template>
  <div
    class="hera-text-section"
    :class="{
      'hera-text-section_single-line d-flex align-items-center justify-content-between': singleLine,
    }"
  >
    <SecondaryText
      v-if="title"
      class="hera-text-section__title text-uppercase"
      :size="titleFontSize"
    >
      <slot name="title">
        {{ title }}
      </slot>
    </SecondaryText>
    <!-- <TextBlock class="hera-text-section__description" v-if="showMore" :text="description" /> -->
    <PrimaryText
      class="hera-text-section__description"
      :size="descriptionFontSize"
      v-bind="{ description: descriptionText }"
    >
      <slot name="description">{{ descriptionText }}</slot>
    </PrimaryText>
  </div>
</template>

<script>
import SecondaryText from '@/components/atoms/SecondaryText';
import PrimaryText from '@/components/atoms/PrimaryText';

export default {
  name: 'TournamentTextSection',
  components: {
    SecondaryText,
    PrimaryText,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: [String, Number],
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
    showMore: {
      type: Boolean,
      default: false,
    },
    singleLine: {
      type: Boolean,
      default: false,
    },
    descriptionFontSize: {
      type: Number,
      default: 0.875,
    },
    titleFontSize: {
      type: Number,
      default: 0.675,
    },
  },
  computed: {
    descriptionText() {
      return this.description || this.$t('_web_value-not-available', 'n/a');
    },
  },
};
</script>

<style lang="scss">
.hera-text-section {
  padding-bottom: 24px;

  .hera-text-section__title {
    display: block;
    margin-bottom: 8px;
  }

  .hera-text-section__description {
    line-height: 22px;
    .icon {
      fill: #8261fc;
      margin-left: 9px;
      vertical-align: text-top;
    }
  }

  &_single-line {
    padding-bottom: 0.25rem;
    .hera-text-section__title {
      margin-bottom: 0;
    }
  }
}
</style>
